
(function userDetailControllerDefinition() {
    'use strict';
    angular.module('User')
        .controller('UserDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminUserService', '$stateParams','auth',
            function userDetailController($scope, config, $state, $translate, errors, adminUserService, $stateParams,auth) {
                $translate(['UserDetail']).then(function (translated) {
                    $scope.title = translated.UserDetail;
                });
                $scope.viewAudit = auth.isInRole('AUDIT READ');
                adminUserService.getById($stateParams.id, false).then(function (result) {
                    $scope.user = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('user-find');
                });

                $scope.cancel = function () {
                    $state.go("user-find");
                };

                $scope.viewAuditHistory = function () {
                    var params = [];
                    params.push($scope.user.id);
                    params.push($scope.user.loginId);

                    $state.go('audit-history', {
                        entityName: "USER",
                        entityValues: params,
                        displayName: $scope.user.nickName,
                        organizationalUnitId: $scope.user.organizationalUnitId
                    });
                };
            }
        ]);
})();